<template>
  <div id="log-in-page" class="main-page">
    <div class="container">
      <div class="row row-login-form">
        <div class="col-xl-6 col-lg-6 col-md-5 col-sm-12 text-center col-login-left">
          <img class="login-img" :src="login_img" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-login-right">
          <p class="login-title">Gunspring Login</p>
          <p v-if="message && message != ''">{{message}}</p>
          <p
            class="login-error"
            v-if="wrongCred"
          >The username and password you entered did not match our records. Please double-check and try again.</p>
          <emailInputBase v-model="user_email" label="Email" nameclass="login-input" @keydown.enter="nextPlease" />
          <passwordInputBase v-model="password" label="Password" nameclass="login-input" id="password-login" @keydown.enter="loginUser" />

          <div v-if="loading" class="form-btn-section text-center">
            <!-- <i  class="fas fa-spinner fa-pulse"></i> Loading...</p> -->
            <button disabled class="blue-cta login-btn" type="submit" @click="loginUser"><i class="fa fa-spinner fa-pulse fa fa-fw"></i> Acesssing</button>
          </div>
          <div v-else class="form-btn-section text-center">
            <button class="blue-cta login-btn" type="submit" @click="loginUser">Access Your Account</button>
          </div>

          <div class="text-center">
            <router-link class="recover-password-link" :to="{ name: 'recover' }">Recover Password</router-link>
            <p class="application-sign-in-text">
              Don't have an account?
              <span>
                <router-link :to="{ name:'register' }" class="application-sign-in-link">Sign Up</router-link>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  emailInputBase,
  passwordInputBase
} from "../components/forms/baseForms";
import { mapState } from "vuex";
import Vue from "vue";
export default {
  computed: mapState(["accessToken", "baseApp"]),
  components: {
    emailInputBase,
    passwordInputBase
  },
  data: () => ({
    loading: false,
    user_email: "",
    password: "",
    wrongCred: false,
    message: "",
    login_img: require("@/assets/images/login.png"),
  }),
  methods: {
    nextPlease: function (event) {
        document.getElementById('password-login').focus();
      },
    loginUser() {
      // call loginUSer action
      this.loading = true;
      this.$store
        .dispatch("loginUser", {
          email: this.user_email,
          password: this.password
        })
        .then(is_admin => {
          this.wrongCred = false;
          if (is_admin) {
            this.$router.push({ name: "admin" });
            this.loading = false;
          } else {
            this.$router.push({ name: "userapps" });
            this.loading = false;
          }
        })
        .catch(err => {
          // console.log(err);
          this.wrongCred = true; // if the credentials were wrong set wrongCred to true
          this.user_email = "";
          this.password = "";
          this.loading = false;
        });
    }
  },
  created() {
    if (this.$route.query.message === "verify") {
      this.message =
        "Please complete the last step by checking your email for a verification link. Once that is complete, you may log in below.";
    } else if (this.$route.query.message === "confirmed") {
      this.message = "Your email has been confirmed. You may now log in below.";
    }
    else if (this.$route.query.message === "requestreset") {
      this.message = "Please check your email for a password reset link.";
    }
    else if (this.$route.query.message === "resetcomplete") {
      this.message = "Your password has been successfully reset. You may now login below.";
    }
  },
  mounted: () => {}
};
</script>

<style>
.blue-cta:disabled {
  background-image: linear-gradient(45deg, #6c757d 0, #6c757d 100%);
}

.login-img {
  width: 405px;
  padding-top: 75px;
}
.login-error {
  color: #e57373;
  font-weight: 500;
  margin-bottom: 30px;
}

#log-in-page label {
  width: 100%;
  font-weight: 500;
}

#log-in-page input {
  width: 100%;
  padding: 8px 10px;
}

.login-title {
  font-size: 32px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 35px;
}

.login-input {
  margin-bottom: 35px;
}

.row-login-form {
  border-radius: 4px;
  margin: 50px 0 100px 0;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.col-login-right {
  background: #e3f2fd;
  padding: 96px 64px !important;
}

.recover-password-link {
  font-size: 18px;
  font-weight: 500;
  color: #2196f3;
  display: inline-block;
  margin: 25px;
}

.recover-password-link:hover {
  color: #1976d2;
  text-decoration: none;
}

.application-sign-in-link {
  color: #2196f3;
}

.application-sign-in-link:hover {
  color: #1976d2;
  text-decoration: none;
}

@media (max-width: 1199.98px) {
  .row-login-form {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}

@media (max-width: 767.98px) {
  .col-login-left {
    display: none;
  }

  .col-login-right {
    padding: 32px !important;
  }

  .row-login-form {
    margin-bottom: 50px;
  }
}
</style>
